/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CommunicationInfo,
    CommunicationInfoFromJSON,
    CommunicationInfoFromJSONTyped,
    CommunicationInfoToJSON,
    CommunicationStatus,
    CommunicationStatusFromJSON,
    CommunicationStatusFromJSONTyped,
    CommunicationStatusToJSON,
    ObjectTypeEnum,
    ObjectTypeEnumFromJSON,
    ObjectTypeEnumFromJSONTyped,
    ObjectTypeEnumToJSON,
} from './';

/**
 * 
 * @export
 * @interface PutClientCommunication
 */
export interface PutClientCommunication {
    /**
     * 
     * @type {CommunicationStatus}
     * @memberof PutClientCommunication
     */
    status?: CommunicationStatus;
    /**
     * 
     * @type {ObjectTypeEnum}
     * @memberof PutClientCommunication
     */
    sharedWithObjectType?: ObjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PutClientCommunication
     */
    sharedWithObjectId?: string | null;
    /**
     * 
     * @type {CommunicationInfo}
     * @memberof PutClientCommunication
     */
    communicationInfo?: CommunicationInfo;
}

export function PutClientCommunicationFromJSON(json: any): PutClientCommunication {
    return PutClientCommunicationFromJSONTyped(json, false);
}

export function PutClientCommunicationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutClientCommunication {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : CommunicationStatusFromJSON(json['status']),
        'sharedWithObjectType': !exists(json, 'sharedWithObjectType') ? undefined : ObjectTypeEnumFromJSON(json['sharedWithObjectType']),
        'sharedWithObjectId': !exists(json, 'sharedWithObjectId') ? undefined : json['sharedWithObjectId'],
        'communicationInfo': !exists(json, 'communicationInfo') ? undefined : CommunicationInfoFromJSON(json['communicationInfo']),
    };
}

export function PutClientCommunicationToJSON(value?: PutClientCommunication | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': CommunicationStatusToJSON(value.status),
        'sharedWithObjectType': ObjectTypeEnumToJSON(value.sharedWithObjectType),
        'sharedWithObjectId': value.sharedWithObjectId,
        'communicationInfo': CommunicationInfoToJSON(value.communicationInfo),
    };
}


